import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import axios from 'axios';
import { RatingAPI } from '../../../constants/API';
import { commonHeaders } from '../../../constants/HeadersAPI';
import { defaultSuccessMessage } from '../../../constants/alertText';
import { AlertContext } from '../../../context/AlertProvider';
import { AlertType } from '../../../types/enums';
import { RatingSettingsDto } from '../../../types/Rating/RatingTypes';

export const usePutRatingSettings = (branchQueueId: number | null) => {
  const queryClient = useQueryClient();
  const context = useContext(AlertContext);
  return useMutation(
    (payload: Partial<RatingSettingsDto> & { screensaverMediaIds?: number[] }) =>
      axios.put(RatingAPI.updateSettings(branchQueueId!), payload, commonHeaders()),
    {
      onSuccess: () => {
        queryClient
          .invalidateQueries(['ratingSettings', branchQueueId])
          .then(() =>
            context?.setAlert({ type: AlertType.Success, message: defaultSuccessMessage })
          );
      }
    }
  );
};
